export default __webpack_public_path__ + "static/media/nc.2dc2599f.png";